// extracted by mini-css-extract-plugin
module.exports = {"table":"DropdownEditor_table","input":"DropdownEditor_input"};